import React from "react";
import OrderTitle from "@/components/management/components/order/OrderTitle";
import OrderTable from "@/components/management/components/order/OrderTable";
import BranchRequiredWrapper from "@/components/banners/BranchRequiredWrapper";

const Orders: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-2">
      <BranchRequiredWrapper>
        <OrderTitle />
        <OrderTable />
      </BranchRequiredWrapper>
    </div>
  );
};

export default Orders;
